const menuCols = {
  menus: document.querySelectorAll('.desk-nav__sublist-list--menu-list') as NodeListOf<HTMLElement>,

  init() {
    if (window.innerWidth < 1200) return;

    this.setLayout();
  },

  setLayout() {
    this.menus.forEach(menu => {
      if (menu.classList.contains('desk-nav__sublist-list--layout-ready')) return;

      const cols = parseInt(menu.dataset.menuCols || '3', 10);
      const maxRows = parseInt(menu.dataset.menuRows || '999', 10);
      const layoutMode = menu.dataset.menuLayout || 'balanced';

      const items = Array.from(
        menu.querySelectorAll(':scope > .desk-nav__subitem--lvl2')
      ) as HTMLElement[];

      if (!items.length) return;

      const finalCols =
        layoutMode === 'rows'
          ? this.createRowBasedColumns(items, cols, maxRows)
          : this.createBalancedColumns(items, cols);

      const fragment = document.createDocumentFragment();

      finalCols.forEach((colItems, colIndex) => {
        const col = document.createElement('li');
        col.className = 'desk-nav__layout-col';
        col.dataset.col = String(colIndex + 1);

        const inner = document.createElement('div');
        inner.className = 'desk-nav__layout-col-inner';

        colItems.forEach(item => inner.appendChild(item));

        col.appendChild(inner);
        fragment.appendChild(col);
      });

      menu.innerHTML = '';
      menu.appendChild(fragment);

      menu.classList.add('desk-nav__sublist-list--layout-ready');
      menu.style.setProperty('--menu-cols', String(finalCols.length));
    });
  },

  createBalancedColumns(items: HTMLElement[], cols: number) {
    const columnCount = Math.min(cols, items.length);
    const columns: HTMLElement[][] = Array.from({ length: columnCount }, () => []);

    items.forEach((item, index) => {
      const colIndex = index % columnCount;
      columns[colIndex].push(item);
    });

    return columns;
  },

  createRowBasedColumns(items: HTMLElement[], cols: number, maxRows: number) {
    const columns: HTMLElement[][] = [];
    let currentCol: HTMLElement[] = [];

    items.forEach(item => {
      if (currentCol.length >= maxRows) {
        columns.push(currentCol);
        currentCol = [];
      }

      currentCol.push(item);
    });

    if (currentCol.length) {
      columns.push(currentCol);
    }

    const finalCols = columns.slice(0, cols);

    if (columns.length > cols && finalCols.length) {
      const overflow = columns
        .slice(cols)
        .reduce((acc, col) => acc.concat(col), [] as HTMLElement[]);

      finalCols[cols - 1].push(...overflow);
    }

    return finalCols;
  }
};

export default menuCols;